import React from "react";
import Icon from "../primitives/icon";

interface NewsTagProps {
  icon?: string;
  label: string;
}
export default function NewsTag(props: NewsTagProps) {
  return (
    <div className="flex justify-center items-center bg-dark fill-primary text-white rounded-full gap-1 px-2 h-6 text-title-sm-bold uppercase">
      {props.icon && <Icon name={props.icon} size="sm" />}
      {props.label}
    </div>
  );
}
